"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var moment = require("moment");
var MASKED_DATEPICKER_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return MaskedDatepickerComponent; }),
    multi: true
};
var MaskedDatepickerComponent = (function () {
    function MaskedDatepickerComponent(elementRef) {
        this.elementRef = elementRef;
        this.displayFormat = 'MM/DD/YYYY';
        this.parseFormat = 'YYYY-MM-DD';
        this.mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
        this.dateValue = '';
        this.propagateChange = function (_) { };
        this.onTouched = function () { };
    }
    MaskedDatepickerComponent.prototype.ngAfterContentInit = function () {
        if (this.selectedDate) {
            this.setValuesFromString(moment(this.selectedDate, this.parseFormat).format(this.displayFormat));
        }
    };
    MaskedDatepickerComponent.prototype.ngOnChanges = function (changes) {
        if (changes['maxDate']) {
            if (this.maxDate) {
                this.maxDateValue = this.getDateStructValue(this.maxDate);
            }
        }
        if (changes['minDate']) {
            if (this.minDate) {
                this.minDateValue = this.getDateStructValue(this.minDate);
            }
        }
    };
    MaskedDatepickerComponent.prototype.writeValue = function (obj) {
        this.setValuesFromString(moment(obj, this.parseFormat).format(this.displayFormat));
    };
    MaskedDatepickerComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    MaskedDatepickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    MaskedDatepickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    MaskedDatepickerComponent.prototype.sendPropagateChange = function (value) {
        var propagateValue = '';
        if (value) {
            propagateValue = moment(value, this.displayFormat).format(this.parseFormat);
        }
        this.propagateChange(propagateValue);
    };
    MaskedDatepickerComponent.prototype.setPlaceholder = function () {
        this.oldPlaceholder = this.placeholder;
        this.placeholder = 'mm/dd/yyyy';
    };
    MaskedDatepickerComponent.prototype.enteredDateChanged = function (newValue) {
        this.placeholder = this.oldPlaceholder;
        // if the text entered date is valid, it will be set in the datepicker,
        // otherwise emit what was entered
        if (newValue) {
            this.setValuesFromString(newValue);
            this.sendPropagateChange(this.dateValue);
        }
        else {
            this.sendPropagateChange(newValue);
        }
        this.onTouched();
    };
    MaskedDatepickerComponent.prototype.documentClick = function (event) {
        // close datepicker if it is open and a click occurs outside this component
        if (!this.elementRef.nativeElement.contains(event.target)) {
            if (this.datepicker && this.datepicker.isOpen()) {
                this.datepicker.close();
            }
        }
    };
    MaskedDatepickerComponent.prototype.pickedDateChanged = function (newValue) {
        // when the date is changed, set the value on the text input, and then
        // send the value to the parent
        var date = moment(newValue.month + "-" + newValue.day + "-" + newValue.year, 'MM-DD-YYYY');
        this.setDateValueFromMoment(date);
        this.sendPropagateChange(this.dateValue);
        this.onTouched();
    };
    MaskedDatepickerComponent.prototype.setValuesFromString = function (newValue) {
        var date = moment(newValue, this.displayFormat);
        if (date.isValid()) {
            this.setDateValueFromMoment(date);
            this.datepickerValue = { day: date.date(), month: date.month() + 1, year: date.year() };
        }
        else {
            this.dateValue = newValue;
            this.datepickerValue = { day: null, month: null, year: null };
        }
    };
    MaskedDatepickerComponent.prototype.setDateValueFromMoment = function (date) {
        this.dateValue = date.format(this.displayFormat);
    };
    MaskedDatepickerComponent.prototype.getDateStructValue = function (newValue) {
        var date = moment(newValue, this.parseFormat);
        if (date.isValid()) {
            return { day: date.date(), month: date.month() + 1, year: date.year() };
        }
        else {
            return { day: null, month: null, year: null };
        }
    };
    // function for styling of template
    MaskedDatepickerComponent.prototype.isCurrent = function (date) {
        var d = moment(new Date(date.year, date.month - 1, date.day));
        return d.startOf('day').isSame(moment().startOf('day'));
    };
    MaskedDatepickerComponent.prototype.canSelect = function (date) {
        var d = moment(new Date(date.year, date.month - 1, date.day));
        if (this.maxDateValue) {
            var maxValue = moment(new Date(this.maxDateValue.year, this.maxDateValue.month - 1, this.maxDateValue.day));
            if (d.isAfter(maxValue)) {
                return false;
            }
        }
        if (this.minDateValue) {
            var minValue = moment(new Date(this.minDateValue.year, this.minDateValue.month - 1, this.minDateValue.day));
            if (d.isBefore(minValue)) {
                return false;
            }
        }
        return true;
    };
    return MaskedDatepickerComponent;
}());
__decorate([
    core_1.ViewChild('d'),
    __metadata("design:type", ng_bootstrap_1.NgbInputDatepicker)
], MaskedDatepickerComponent.prototype, "datepicker", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], MaskedDatepickerComponent.prototype, "selectedDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], MaskedDatepickerComponent.prototype, "placeholder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], MaskedDatepickerComponent.prototype, "isDisabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], MaskedDatepickerComponent.prototype, "displayFormat", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], MaskedDatepickerComponent.prototype, "parseFormat", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], MaskedDatepickerComponent.prototype, "maxDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], MaskedDatepickerComponent.prototype, "minDate", void 0);
MaskedDatepickerComponent = __decorate([
    core_1.Component({
        selector: 'masked-datepicker',
        template: "<div class=\"input-group\">     <input class=\"form-control\" [disabled]=\"isDisabled\" [placeholder]=\"placeholder ? placeholder : ''\" [textMask]=\"{mask: mask}\" [ngModel]=\"dateValue\" (blur)=\"enteredDateChanged($event.target.value)\" (click)=\"setPlaceholder()\">     <input class=\"form-control hidden\"          [markDisabled]=\"isDisabled\"         [maxDate]=\"maxDateValue\"         [minDate]=\"minDateValue\"         [navigation]=\"'arrows'\"          [firstDayOfWeek]=\"7\"          ngbDatepicker          #d=\"ngbDatepicker\"         [dayTemplate]=\"customDay\"         [(ngModel)]=\"datepickerValue\"          (ngModelChange)=\"pickedDateChanged($event)\">     <span class=\"input-group-btn\">         <button class=\"btn btn-default\" type=\"button\" (click)=\"d.toggle();\" [disabled]=\"isDisabled\">             <span class=\"glyphicon glyphicon-calendar\"></span>         </button>     </span> </div>  <template #customDay let-date=\"date\" let-currentMonth=\"currentMonth\" let-selected=\"selected\" let-disabled=\"disabled\">   <span class=\"custom-day\" [class.current]=\"isCurrent(date)\" [class.outside-month]=\"date.month !== currentMonth\"         [class.bg-primary]=\"selected\" [class.text-muted]=\"disabled\" [class.unselectable]=\"!canSelect(date)\">     {{ date.day }}   </span> </template>",
        host: {
            '(document:click)': 'documentClick($event);'
        },
        providers: [MASKED_DATEPICKER_VALUE_ACCESSOR],
        styles: ["\n        :host /deep/ .w-100 {\n            width: 100%;\n        }\n\n        :host /deep/ .text-sm-right {\n            float: right;\n        }\n\n        :host /deep/ ngb-datepicker {\n            top: 100% !important;\n            width: 225px;\n            padding: 10px !important;\n        }\n\n        :host /deep/ ngb-datepicker div {\n            width: 100% !important;\n        }\n\n        // custom date classes\n        .custom-day {\n            text-align: center;\n            padding: 0.185rem 0.25rem;\n            border-radius: 0.25rem;\n            display: inline-block;\n            width: 2rem;\n            color: #000;\n        }\n\n        .custom-day:hover {\n            background-color: #e6e6e6;\n        }\n\n        .current {\n            color: orange;\n        }\n\n        .outside-month {\n            color: lightslategray;\n        }\n\n        .unselectable {\n            color: lightgray;\n        }\n\n        .unselectable:hover {\n            background-color: #FFF;\n        }\n\n        .hidden {\n            display: none;\n        }\n\n        // datepicker uses these bootstrap 4 classes\n        :host /deep/ .rounded {\n            border-radius: 0.25rem;\n        }\n        :host /deep/ .d-flex {\n            display: -webkit-box !important;\n            display: -webkit-flex !important;\n            display: -ms-flexbox !important;\n            display: flex !important;\n        }\n\n        :host /deep/ .d-inline-flex {\n            display: -webkit-inline-box !important;\n            display: -webkit-inline-flex !important;\n            display: -ms-inline-flexbox !important;\n            display: inline-flex !important;\n        }\n\n        :host /deep/ .d-none {\n            display: none !important;\n        }\n\n        :host /deep/ .d-inline {\n            display: inline !important;\n        }\n\n        :host /deep/ .d-inline-block {\n            display: inline-block !important;\n        }\n\n        :host /deep/ .d-block {\n            display: block !important;\n        }\n\n        :host /deep/ .justify-content-between {\n            -webkit-box-pack: justify !important;\n            -webkit-justify-content: space-between !important;\n            -ms-flex-pack: justify !important;\n            justify-content: space-between !important;\n        }\n\n        :host /deep/ .text-info {\n            color: #5bc0de !important;\n        }\n\n        :host /deep/ a.text-info:focus, a.text-info:hover {\n            color: #31b0d5 !important;\n        }\n        // end bootstrap 4 classes\n    "]
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], MaskedDatepickerComponent);
exports.MaskedDatepickerComponent = MaskedDatepickerComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/masked-datepicker/masked-datepicker.component.js